import { render, staticRenderFns } from "./default.vue?vue&type=template&id=1c7f79e7&scoped=true&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=1c7f79e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7f79e7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('D:/phpstudy_pro/WWW/disk/components/Loading/index.vue').default,Navbar: require('D:/phpstudy_pro/WWW/disk/components/Navbar/index.vue').default,Sidebar: require('D:/phpstudy_pro/WWW/disk/components/Sidebar/index.vue').default,RightMenuBar: require('D:/phpstudy_pro/WWW/disk/components/RightMenuBar/index.vue').default,BatchDownload: require('D:/phpstudy_pro/WWW/disk/components/BatchDownload/index.vue').default})
